export const imageUrl = (name: string) =>
  "https://api.lifeofmarrow.com/images?img=" + name;
// (process.env.NODE_ENV === "production"
//     ? "https://api.lifeofmarrow.com/images?img="
//     : "http://localhost:4000/images?img=")
